import { LinkToPayerEnum, PayerTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export function getTripLinkToPayer(
  isRideOrderingPortalUser: boolean,
  shouldLinkPassengerToPayer: boolean,
  payerType?: PayerTypeEnum
): LinkToPayerEnum | null {
  if (
    isRideOrderingPortalUser ||
    (payerType === 'private' && shouldLinkPassengerToPayer)
  ) {
    return 'always';
  }

  if (shouldLinkPassengerToPayer) {
    return 'only_with_id';
  }

  return null;
}
